<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row>
        <v-col cols="12" md="6" sm="12">
          <v-btn color="secondary" outlined class="mr-1" to="/admin/reports">
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to Reports
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" sm="12" class="user-report-button-wrapper">
          <v-btn
            class="mr-1 add-course-button"
            color="primary"
            @click.prevent="exportCsv('excel')"
            outlined
          >
          Email link to download Excel report
          </v-btn>
          <!-- <v-btn
            class="mr-1 add-course-button"
            color="primary"
            @click.prevent="exportCsv('pdf')"
            outlined
          >
            Email Report <v-icon class="ml-1">mdi-file-pdf-box</v-icon>
          </v-btn> -->
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="Full-Course-Library-Title">
          User Reports
        </v-col>
        <v-col md="12">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Users By Name Or Email"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applySearch"
              ></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="computedHeaders"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="users"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
              }"
            >
            <template v-slot:item.total_published_courses="{ item }">
                    <span v-if="item.total_published_courses" class="clickable-count" @click.stop="openDialog($event,item.published_courses,'Courses')">{{ item.total_published_courses }}</span>
                    <span v-else>{{ item.total_published_courses }}</span>
              </template>
              <template v-slot:item.total_in_progress="{ item }">
                    <span v-if="item.total_in_progress" class="clickable-count" @click.stop="openDialog($event,item.inprogress_courses,'In Progress Courses')">{{ item.total_in_progress }}</span>
                    <span v-else>{{ item.total_in_progress }}</span>
              </template>
              <template v-slot:item.total_completed_courses="{ item }">
                    <span v-if="item.total_completed_courses" class="clickable-count" @click.stop="openDialog($event,item.completed_courses,'Completed Courses')">{{ item.total_completed_courses }}</span>
                    <span v-else>{{ item.total_completed_courses }}</span>
              </template>
              <template v-slot:item.total_groups="{ item }">
                    <span v-if="item.total_groups" class="clickable-count" @click.stop="openDialog($event,item.groups,'Groups')">{{ item.total_groups }}</span>
                    <span v-else>{{ item.total_groups }}</span>
              </template>
              <template v-slot:item.total_channels="{ item }">
                    <span v-if="item.total_channels" class="clickable-count" @click.stop="openDialog($event,item.channels,'Playlists')">{{ item.total_channels }}</span>
                    <span v-else>{{ item.total_channels }}</span>
              </template>
              <template v-slot:item.total_team_managers="{ item }">
                    <span v-if="item.total_team_managers" class="clickable-count" @click.stop="openDialog($event,item.team_managers,'Team Managers')">{{ item.total_team_managers }}</span>
                    <span v-else>{{ item.total_team_managers }}</span>
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="item.id"
                      v-on="on"
                      text
                      small
                      class="mr-1"
                      :to="'/admin/user-course-report/' + item.id"
                    >
                      <v-icon small>fas fa-chart-line</v-icon>
                    </v-btn>
                  </template>
                  <span>User Course Report</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- Dialog -->
      <DialogComponent
        :isOpen="dialog"
        :dialogTitle="dialogTitle"
        :dialogData="dialogData"
        @close="closeDialog"
        />
    </v-container>
  </layout-basic>
</template>

<script>
import userAPI from '@/api/user.js';
import companyAPI from '@/api/company.js';
import LayoutBasic from '@/layouts/Dashboard';
import DialogComponent from '@/components/Dialog';

export default {
  name: 'UsersReport',
  components: {
    LayoutBasic,
    DialogComponent
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name', align: 'left' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Last Login', value: 'last_login', sortable: false },
        { text: 'Courses', value: 'total_published_courses', sortable: false },
        { text: 'Groups', value: 'total_groups', sortable: false },
        { text: 'Playlists', value: 'total_channels', sortable: false },
        { text: 'In Progress', value: 'total_in_progress', sortable: false },
        {
          text: 'Completed',
          value: 'total_completed_courses',
          sortable: false,
        },
        { text: 'Team Managers', value: 'total_team_managers', sortable: false },
        { text: '', value: 'id', align: 'end' },
      ],
      users: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      dialog: false,
      dialogTitle : '',
      dialogData: [],
      successMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
      locations: [],
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.locations.length) {
        headers.splice(3, 0, { text: `${this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}`, value: 'site_name', sortable: false });
      }
      return headers;
    },
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
  },
  mounted() {
    this.getCompanySites();
    this.loadSearch();
  },
  methods: {
    getUsers() {
      this.loading = true;
      this.searchParams =
        this.search && this.search.length > 0
          ? '&search=first_name:' + this.search + ';last_name:' + this.search + ';email:' + this.search
          : '';
      userAPI.getClients(this.params, this.searchParams).then((resp) => {
        this.users = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '';
      this.getUsers();
      localStorage.removeItem('user-report-search');
    },
    applySearch() {
      this.options.page = 1;
      this.getUsers();
      this.saveSearch();
    },
    exportCsv(type) {
      this.loading = true;
      userAPI
        .exportUserCSV(
          '?page=1&orderBy=&sortedBy=asc&limit=' + this.pagination.total,
          '',
          '&type=' + type
        )
        .then((resp) => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getCompanySites() {
        companyAPI.getCompanySites().then(response => {
            this.locations = response.data.data;
        });
    },
    openDialog(event, data, title) {
      this.dialogTitle = title;
      this.dialogData = data;
      this.dialog = true;
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.dialog = false;
    },
    saveSearch() {
      // Save search value to localStorage
      localStorage.setItem('user-report-search', this.search);
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('user-report-search');
      
      if (savedSearch && savedSearch !== 'null') {
        this.search = savedSearch;
      }
    },
  },
};
</script>

<style>
.user-report-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}

@media (max-width: 960px) {
  .user-report-button-wrapper {
    justify-content: start;
  }
}

@media (max-width: 390px) {
    .user-report-button-wrapper {
        justify-content: center;
    }
    .add-course-button span{
      font-size: 12px !important;
    }
}
</style>
